export class RestoreAwsEc2InstanceInstantRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoreAccountId",
            "baseName": "restoreAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "destination",
            "baseName": "destination",
            "type": "AwsEc2InstanceRestoreDestination",
            "format": ""
        },
        {
            "name": "instantRestoreOptions",
            "baseName": "instantRestoreOptions",
            "type": "InstantRestoreOptions",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreAwsEc2InstanceInstantRequest.attributeTypeMap;
    }
    constructor() {
    }
}
